module.exports = __webpack_public_path__ + "img/uterus.f508fb12.svg";